import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { userApi } from '../../api/users';

export function UserCreatePage() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const u = await userApi.create({ email, display_name: displayName });
      nav(`/users/${u.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Create failed');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-lg p-6">
      <Link to="/users" className="text-sm text-slate-600 hover:underline">← User directory</Link>
      <h1 className="mt-4 text-2xl font-semibold">Add user</h1>
      <form onSubmit={(e) => void onSubmit(e)} className="mt-6 space-y-4">
        <label className="block text-sm">
          Email
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-lg border px-3 py-2" />
        </label>
        <label className="block text-sm">
          Display name
          <input required value={displayName} onChange={(e) => setDisplayName(e.target.value)} className="mt-1 w-full rounded-lg border px-3 py-2" />
        </label>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button type="submit" disabled={saving} className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-50">
          {saving ? 'Creating…' : 'Create user'}
        </button>
      </form>
    </div>
  );
}
